import '../styles/common.css';
import catGif from '../assets/gif/cat.gif'; // 导入新动图
import BackBase from '../assets/images/app/5.webp';
import Footer from './Footer'
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
    const navigate = useNavigate();
    return (
        <div className='relative'>
            <img src={BackBase} alt="BackBase" className="w-full h-auto" />
            <div className="absolute w-auto top-[2.6vw] left-[6vw]  z-[9999]">
                <div className="relative inline-flex items-end gap-2"> {/* 新增间隙 */}
                    <span className="text-[#000] text-[2vw] font-['TsangerTQXKW']">天籁瓷鉴</span>
                    <span className="text-[1.2vw] text-[#000] transform translate-x-[0.2vw] -translate-y-[0.4vw]">Tianlai.China</span>
                </div>
            </div>
            <div className='absolute top-[15%] left-[0%] w-full h-auto'>
                <div className="flex w-full h-full justify-center items-center bg-base flex-col">
                    <img src={catGif} alt="catGIF" className="mb-4" />
                    <span className='text-gray-600 text-[1.5vw]'>哎呀，你好像迷路啦，我们正在努力带你回家~呜喵~</span>
                </div>
            </div>
            <div
                className="absolute w-auto bottom-[35%] left-[50%] transform -translate-x-1/2 z-[9999] transparent-rounded-button flex flex-col items-center text-center"
                onClick={() => navigate('/')}>
                <span>返回首页</span>
                <span>Back to Home</span>
            </div>
            <Footer className="mt-auto absolute bottom-0 left-0 w-full" />
        </div>
    );
}